// Cancer and pregnancy question rules shared by PersonalQuestionaire and DependentInfo
// (same behaviour as the common-enrollment health tabs):
//  1. Yes on the cancer question also requires the location/type and stage of the cancer.
//  2. Yes on the pregnancy question stops the review: no condition details, the member
//     cannot save, and later tabs are disabled for as long as it stays Yes. The Yes is
//     recorded on the backend when picked, and rejected there on save and on submit.
import reviewApi from '@/resource/memberReviewApi';

const CANCER_QUESTION_ID = 115;
const PREGNANCY_QUESTION_ID = 144;

export default {
    data: () => ({
        cancerStages: [1, 2, 3, 4],
        pregnancyRestrictionMessage: "We're unable to continue this application because of a pregnancy-related eligibility requirement. Please contact your representative or our support team to explore other coverage options.",
    }),
    methods: {
        isCancerQuestion(question) {
            return !!question && question.question_id == CANCER_QUESTION_ID;
        },

        isPregnancyQuestion(question) {
            return !!question && question.question_id == PREGNANCY_QUESTION_ID;
        },

        isPregnancyYes(question) {
            return this.isPregnancyQuestion(question) && question.selected_answer == 1;
        },

        hasPregnancyYes(healthInfo) {
            return ((healthInfo && healthInfo.condition_questions) || []).some((question) => this.isPregnancyYes(question));
        },

        // Called from the Yes radio's click, so selected_answer still holds the previous answer.
        recordPregnancyYes(question, applicantType) {
            if (question.selected_answer == 1) return;
            reviewApi.recordPregnancyRestriction({ applicant_type: applicantType })
                .catch((err) => console.error('Could not record pregnancy restriction:', err));
        },

        cancerConditionFields(question) {
            return this.isCancerQuestion(question) ? { cancer_type: '', cancer_stage: '' } : {};
        },
    },
};
